import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import {
  Container,
  FormGroup,
  Label,
  Input,
  Button,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody
} from 'reactstrap';
import { connect } from 'react-redux';
import { IClient, IVenteChargeEdit, IVenteChargeEditRedux, ITarget } from '../../types/interfaces';

import TableContainer from "../tables_manager/TableContainer"
import EditableCell from "../tables_manager/EditableCell";
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { getUsers } from '../../flux/actions/userActions';
import { editVenteCharge } from '../../flux/actions/venteActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faPen, faPlus, faSpinner, faSquare, faTimes } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios';
import { E_ERROR } from '../../types/errors';
import { useAlert } from "react-alert";

const VenteChargeEdit = ({
  modal,
  setModal,
  modalVente,
  editVenteCharge,
  getUsers,
  user,
  auth
 }: IVenteChargeEdit) => {
  const alert = useAlert();

  const [idValue, setIdValue] = useState(-1);
  const [isAssociation, setIsAssociation] = useState(false);
  const { users, loading: loadingU } = user;
  const userOptions = users.map(e => ({value: e, label: e.username}));
  const [userValue, setUserValue] = useState<any>('');
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [reEnable, setReEnable] = useState(false);
  
  const handleToggle = () => setModal(!modal);

  useEffect(() => {
    getUsers();
  }, [getUsers]);

  const modalOpenedHandle = () => {
    if(modalVente && modalVente !== ''){
      setIdValue(modalVente["id"]);
      setIsAssociation(!!modalVente["isAssLine"]);
      setUserValue(userOptions.find(e => e.value?.id === Number(modalVente["charge_bien_id"] || 0))?.value || '');
    }
  };

  const modalClosedHandle = () => {
    setIdValue(-1);
    setUserValue('');
    if(reEnable){
      setDisableSubmit(false);
      setReEnable(false);
    }
  };

  const handleUserChange = data => {
    setUserValue(data ? data.value : '');
  };

  const callback = (success) => {
    if(success){
      setReEnable(true);
      setModal(false);
      alert.success("Vente modifiée avec succès");
      return
    }
    alert.error("Une erreur s'est produite");
    setDisableSubmit(false);
  }

  const editHandle = async () => {
    if(!userValue || userValue === ''){
      alert.error("Veuillez sélectionner le commercial");
      return
    }

    setDisableSubmit(true);
    editVenteCharge(idValue, isAssociation, userValue.id, userValue.username, auth?.user?.id, callback);
  };

  return (
    <div>
      <Modal isOpen={modal} toggle={handleToggle} onOpened={modalOpenedHandle} onClosed={modalClosedHandle}>
        <ModalHeader toggle={handleToggle}><FontAwesomeIcon icon={faPen} />&nbsp;&nbsp;Modification</ModalHeader>
        <ModalBody>
            <Container className="linesConfirmationContainer">
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="user">Commercial chargé du bien</Label>
                    <Select
                      name="user"
                      className="reactselect"
                      classNamePrefix="react-select"
                      value={userValue ? {label: userValue["username"], value: userValue} : null}
                      onChange={handleUserChange}
                      placeholder={'Chercher par nom...'}
                      isClearable={true}
                      isLoading={loadingU}
                      loadingMessage={() => 'Chargement...'}
                      noOptionsMessage={() => 'pas de resultat'}
                      isSearchable={true}
                      labelKey='name'
                      // valueKey='countryCode'
                      options={userOptions}
                      menuContainerStyle={{ zIndex: 9999999 }}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row className="justify-content-center">
                <Button
                  className="btn btn-success linesConfirmationBtn"
                  onClick={editHandle}
                  disabled={disableSubmit}
                  ><FontAwesomeIcon icon={disableSubmit ? faSpinner : faCheckCircle} className={disableSubmit ? "spinner" : ""} />&nbsp;&nbsp;Modifier</Button>
              </Row>
            </Container>
        </ModalBody>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state: IVenteChargeEditRedux) => ({
  user: state.user,
  auth: state.auth,
  error: state.error,
});

export default connect(mapStateToProps, { editVenteCharge, getUsers })(VenteChargeEdit);
